import { useState } from 'react';
import CountLink from './CountLink';
import TutorReplacementsDialog from './TutorReplacementsDialog';
import { REASON_LABEL, prefetchReplacements, replacementsUrl } from './tutorReplacements';

// Makes the counts on the Tutor Replacement Count pages clickable and owns the popup:
//   const drill = useTutorReplacementDrilldown(month, 'cro');            // or 'tutor' on the by-tutor page
//   { field: 'replacementCount', ..., render: drill.cell('replacementCount') }       every replacement of the row
//   { field: 'tutor', ..., render: drill.cell('tutor', 'tutor') }                      only that reason's
//   ...
//   {drill.dialog}
const useTutorReplacementDrilldown = (month, mode) => {
  const [open, setOpen] = useState(null);
  const requestFor = (row, reason) => ({
    ...(mode === 'tutor' ? { tutorId: row.entityId } : { croId: row.entityId }),
    reason: reason || null,
    name: row.entityName,
    month,
  });

  const cell = (field, reason) => (row) => (
    <CountLink
      count={row[field]}
      label={`${reason ? `${REASON_LABEL[reason].toLowerCase()} ` : ''}tutor replacements of ${row.entityName}`}
      onOpen={() => setOpen(requestFor(row, reason))}
      onPrefetch={() => prefetchReplacements(replacementsUrl(requestFor(row, reason)))}
    />
  );

  const dialog = open ? <TutorReplacementsDialog request={open} onClose={() => setOpen(null)} /> : null;
  return { cell, dialog };
};

export default useTutorReplacementDrilldown;
